import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Intro from './components/Intro';
import Storyline from './components/Storyline';
import Volumes from './components/Volumes';
import Characters from './components/Characters';
import Ending from './components/Ending';
import Faq from './components/Faq';
import Updates from './components/Updates';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <Storyline />
        <Volumes />
        <Characters />
        <Ending />
        <Faq />
        <Updates />
      </main>
      <Footer />
    </div>
  );
}